import React from 'react';
import { FormField, Label } from '@round/ui-kit';
import { Field, FieldHookConfig, useField } from 'formik';
import ErrorMessage from './ErrorMessage/ErrorMessage';

type Props = Partial<{ label: string }> & FieldHookConfig<string>;

const TextField = ({ label, className, ...props }: Props) => {
    const [field] = useField(props);
    return (
        <FormField className={className}>
            <Label htmlFor={props.name}>{label}</Label>
            <Field id={props.name} {...field} {...props} />
            <ErrorMessage name={props.name} />
        </FormField>
    );
};

export default TextField;
